import { render, staticRenderFns } from "./AddNewClient.vue?vue&type=template&id=e7485fe2&"
import script from "./AddNewClient.vue?vue&type=script&lang=js&"
export * from "./AddNewClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports